<template>
	<pivot class="sa-pivot-edit" width="100%" height="100%" toolbar ref="cmpPivotData" v-bind:report="reportJson" :key="pivotKey" :beforetoolbarcreated="customizeToolbar" :reportcomplete="onReportComplete" />
</template>

<script>
import { Pivot } from "@webdatarocks/vue-webdatarocks";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	components: { Pivot },
	data() {
		return {
			//id: "ec0ab16a-2bce-43c0-a9f8-061d638b4968",
			id: null,
			idQuery: null,
			pathResourceData: "/dataanalysisdatabaseinfo/eseguianaliticquery",
			pivotKey: 0,
			dashboardParams: {},
			pivotParams: { fieldsParam: [] },
			reportJson: {
				dataSource: { data: [] },
				slice: {
					rows: [],
					columns: [],
					measures: [],
				},
				localization: "lang/pivottable/it.json",
			},
			customizeToolbar: (toolbar) => {
				// Get all tabs from the Toolbar
				let tabs = toolbar.getTabs();
				if (tabs.length > 0) {
					// Delete the Connect tab
					tabs = tabs.filter((tab) => tab.id !== "wdr-tab-connect");
					tabs = tabs.filter((tab) => tab.id !== "wdr-tab-fullscreen");
					tabs = tabs.filter((tab) => tab.id !== "wdr-tab-open");
					tabs = tabs.filter((tab) => tab.id !== "wdr-tab-options");
					tabs = tabs.filter((tab) => tab.id !== "wdr-tab-save");
					tabs = tabs.filter((tab) => tab.id !== "wdr-tab-format");
				}
				toolbar.getTabs = () => tabs;
			},
		};
	},
	methods: {
		init(chartParams) {
			let me = this;
			me.idQuery = chartParams.idQuery;
			me.pivotParams = chartParams.pivotParams ? JSON.parse(JSON.stringify(chartParams.pivotParams)) : { fieldsParam: [] };
			me.reportJson.slice = me.pivotParams.slice ? me.pivotParams.slice : { rows: [], columns: [], measures: [] };
			me.loadData();
		},
		loadData() {
			let me = this;
			me.loadDataResources(me.pathResourceData + "/" + me.idQuery, {}, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.reportJson.dataSource.data = response.data.data;
			if (me.reportJson.dataSource.data.length > 0) {
				if (me.pivotParams.fieldsParam.length === 0) {
					let record = me.reportJson.dataSource.data[0];
					for (var key of Object.keys(record)) {
						me.pivotParams.fieldsParam.push({ uniqueName: key, caption: key, type: "string" });
					}
				} else {
					me.reportJson.dataSource.data.unshift(me.getDataConfig());
				}
			}
			me.pivotKey++;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			console.log(error);
		},
		getDataConfig() {
			let me = this;
			let dataConfig = {};
			for (var field of me.pivotParams.fieldsParam) {
				dataConfig[field.uniqueName] = { type: field.type, caption: field.caption };
			}

			return dataConfig;
		},
		onReportComplete() {},
	},
};
</script>

<style></style>
